import React from 'react';
const ProductCard = ({
  image,
  title,
  url
}) => <a href={url} target="_blank" rel="noopener noreferrer" className="bg-white rounded-lg overflow-hidden shadow-md block transition-transform hover:scale-105" data-id="element-116">
    <div className="relative" data-id="element-117">
      <img src={image} alt={title} className="w-full h-64 object-cover" data-id="element-118" />
    </div>
    <div className="p-4" data-id="element-119">
      <h3 className="font-bold text-lg mb-1 text-center" data-id="element-120">{title}</h3>
    </div>
  </a>;
export const ProductShowcase = () => {
  const products = [{
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5RAqtePqnUXFt9Sb6E4EvU/Screenshot_2025-07-06_at_12.26.43_AM.png',
    title: 'Panther Chain - New!',
    url: 'https://frznjewelry.co/products/panther-chain-24-7'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7z8qJ6EDWjwutk2XYL5gpd/Screenshot_2025-07-06_at_12.26.54_AM.png',
    title: 'FRZN Mystery Box',
    url: 'https://frznjewelry.co/products/frzn-mystery-box-new-copy-3'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/65RC6rQ489iqCdjZJrijfU/Screenshot_2025-07-06_at_12.27.08_AM.png',
    title: '14mm Diamond Prong Cuban Chain',
    url: 'https://frznjewelry.co/products/copy-of-14mm-diamond-prong-link-chain-white-gold-1'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hKi7j67AY2PMRsnHerKi1e/Screenshot_2025-07-06_at_12.27.22_AM.png',
    title: '3mm Tennis Chain - White Gold',
    url: 'https://frznjewelry.co/products/3mm-tennis-chain-white-gold-lt'
  }];
  return <div id="shop-now" className="w-full bg-gray-50 py-12 px-4 md:px-8" data-id="element-121">
      <div className="max-w-4xl mx-auto" data-id="element-122">
        <h2 className="text-3xl font-bold mb-2 text-center" data-id="element-123">
          Limited Stock Available
        </h2>
        <p className="text-center text-lg mb-8" data-id="element-124">
          Here are some of our most popular pieces
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-125">
          {products.map((product, index) => <ProductCard key={index} {...product} data-id="element-126" />)}
        </div>
        <div className="text-center mt-8" data-id="element-127">
          <a href="https://frznjewelry.co" target="_blank" rel="noopener noreferrer" className="inline-block bg-black text-white font-bold px-8 py-3 rounded-full text-lg hover:bg-gray-800 transition-colors" data-id="element-128">
            VIEW ALL PRODUCTS
          </a>
        </div>
      </div>
    </div>;
};